/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-duplicate-props */
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import ManualRequestForm from "./ManualRequestForm";
// import API_BASE_URL from "../config";

// // // // import React, { useEffect, useState } from "react";
// // // // import axios from "axios";
// // // // import ManualRequestForm from "./ManualRequestForm";
// // // // const DriverAdvance = () => {
// // // //   const [advances, setAdvances] = useState([]);
// // // //   const [records, setRecords] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [showManualForm, setShowManualForm] = useState(false);
// // // //   const [searchTerm, setSearchTerm] = useState("");
// // // //   const toggleManualForm = () => {
// // // //     setShowManualForm(!showManualForm);
// // // //   };

// // // //   // ✅ Fetch advance requests
// // // //   const fetchAdvanceRequests = async () => {
// // // //     try {
// // // //       const pendingResponse = await axios.get(
// // // //         API_BASE_URL + "/advance/pending"
// // // //       );
// // // //       setAdvances(pendingResponse.data);

// // // //       // 2) Get Approved/Rejected
// // // //       const recordsResponse = await axios.get(
// // // //         API_BASE_URL + "/advance/records"
// // // //       );
// // // //       setRecords(recordsResponse.data);
// // // //       setLoading(false);
// // // //     } catch (error) {
// // // //       console.error("Error fetching advance requests:", error);
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     fetchAdvanceRequests();
// // // //   }, []);

// // // //   const handleApproval = async (advanceId, status, requestedAmount) => {
// // // //     let approvedAmount = 0;
// // // //     if (status === "Approved") {
// // // //       approvedAmount = parseFloat(prompt(`Enter approved amount:`));

// // // //       if (
// // // //         isNaN(approvedAmount) ||
// // // //         approvedAmount <= 0 ||
// // // //         approvedAmount > requestedAmount
// // // //       ) {
// // // //         alert(
// // // //           `Invalid approved amount. It should be a number and <= ₹${requestedAmount}`
// // // //         );
// // // //         return;
// // // //       }
// // // //     }

// // // //     try {
// // // //       await axios.post(API_BASE_URL + "/advance/approve", {
// // // //         advanceId,
// // // //         status,
// // // //         approvedAmount,
// // // //         approvedAt: new Date(), // Save the approval date
// // // //         adminId: "admin123", // Example adminId
// // // //         adminName: "Admin User", // Example adminName
// // // //       });

// // // //       alert(`Advance ${status} successfully`);
// // // //       fetchAdvanceRequests(); // <--- Re-fetch your data here!
// // // //     } catch (error) {
// // // //       console.error(`Error ${status.toLowerCase()}ing advance request:`, error);
// // // //       alert("Error: " + (error?.response?.data?.message || error.message || "Failed to update advance request."));
// // // //     }
// // // //   };
// // // //   const handleSearch = (e) => {
// // // //     setSearchTerm(e.target.value);
// // // //   };

// // // //   const filteredRecords = records.filter(
// // // //     (record) =>
// // // //       record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
// // // //       record.driverName.toLowerCase().includes(searchTerm.toLowerCase())
// // // //   );

// // // //   return (
// // // //     <div
// // // //       style={{
// // // //         padding: "20px",
// // // //         background: "white",
// // // //         color: "black",
// // // //         maxWidth: "100%",
// // // //         margin: "auto",
// // // //         borderRadius: "10px",

// // // //         marginLeft:"10%"
// // // //       }}
// // // //     >
// // // //       <h2
// // // //         style={{
// // // //           textAlign: "center",
// // // //           fontSize: "34px",
// // // //           background: "#FFC107",
// // // //           color: "black",
// // // //           padding: "10px",
// // // //           borderRadius: "8px",
// // // //           marginBottom: "60px",
// // // //         }}
// // // //       >
// // // //         Advance Approval Management
// // // //       </h2>
// // // //       <div>
// // // //         <button onClick={toggleManualForm} style={manualButtonStyle}>
// // // //           Add Manual Advance Request
// // // //         </button>

// // // //         {showManualForm && (
// // // //           <ManualRequestForm
// // // //             onClose={toggleManualForm}
// // // //             refreshData={fetchAdvanceRequests}
// // // //           />
// // // //         )}
// // // //       </div>
// // // //       {loading ? (
// // // //         <p>Loading advance requests...</p>
// // // //       ) : advances.length === 0 ? (
// // // //         <p>No advance requests available.</p>
// // // //       ) : (
// // // //         <>
// // // //           <h3>Pending Advance Requests</h3>
// // // //           <table style={{ width: "100%", borderCollapse: "collapse" }}>
// // // //             <thead>
// // // //               <tr
// // // //                 style={{
// // // //                   background: "#007bff",
// // // //                   color: "white",
// // // //                   fontSize: "24px",
// // // //                   paddingTop: "2rem",
// // // //                 }}
// // // //               >
// // // //                 <th>Driver Id</th>
// // // //                 <th>Driver Name</th>
// // // //                 <th>Month</th>
// // // //                 <th>Requested Amount</th>
// // // //                 <th>Action</th>
// // // //               </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //               {advances.map((advance) => (
// // // //                 <tr
// // // //                   key={advance._id}
// // // //                   style={{ borderBottom: "1px solid #ddd" }}
// // // //                 >
// // // //                   <td style={tdStyle}>{advance.driverId}</td>
// // // //                   <td style={tdStyle}>{advance.driverName}</td>
// // // //                   <td style={tdStyle}>{advance.month}</td>
// // // //                   <td style={tdStyle}>₹{advance.requestedAmount}</td>
// // // //                   <td style={tdStyle}>
// // // //                     <button
// // // //                       onClick={() =>
// // // //                         handleApproval(
// // // //                           advance._id,
// // // //                           "Approved",
// // // //                           advance.requestedAmount
// // // //                         )
// // // //                       }
// // // //                       style={approveButtonStyle}
// // // //                     >
// // // //                       Approve
// // // //                     </button>
// // // //                     <button
// // // //                       onClick={() =>
// // // //                         handleApproval(
// // // //                           advance._id,
// // // //                           "Rejected",
// // // //                           advance.requestedAmount
// // // //                         )
// // // //                       }
// // // //                       style={rejectButtonStyle}
// // // //                     >
// // // //                       Reject
// // // //                     </button>
// // // //                   </td>
// // // //                 </tr>
// // // //               ))}
// // // //             </tbody>
// // // //           </table>
// // // //         </>
// // // //       )}

// // // //       {records.length > 0 && (
// // // //         <>
// // // //           <h3>Records Table</h3>
// // // //           <input
// // // //             type="text"
// // // //             placeholder="Search by Driver Id or Name"
// // // //             value={searchTerm}
// // // //             onChange={handleSearch}
// // // //             style={{ marginBottom: "20px", padding: "10px", width: "99%" }}
// // // //           />
// // // //           <table style={{ width: "100%", borderCollapse: "collapse",textAlign:"center" }}>
// // // //             <thead>
// // // //               <tr
// // // //                 style={{
// // // //                   background: "black",
// // // //                   color: "white",
// // // //                   fontSize: "24px",
// // // //                   paddingTop: "2rem",
// // // //                   textAlign: "center",
// // // //                   height:"3rem"
// // // //                 }}
// // // //               >
// // // //                 <th>Driver Id</th>
// // // //                 <th>Driver Name</th>
// // // //                 <th>Date</th>
// // // //                 <th>Requested Amount</th>
// // // //                 <th>Approved Amount</th>
// // // //                 <th>Status</th>
// // // //                 <th>Deducted Month</th>
// // // //               </tr>
// // // //             </thead>
// // // //             <tbody>
// // // //               {filteredRecords.map((record) => (
// // // //                 <tr key={record._id} style={{ borderBottom: "1px solid #ddd" }}>
// // // //                   <td>{record.driverId}</td>
// // // //                   <td>{record.driverName}</td>
// // // //                   <td>{record.month}</td>
// // // //                   <td>₹{record.requestedAmount}</td>
// // // //                   <td>{record.approvalStatus === "Approved" ? `₹${record.approvedAmount}` : "-"}</td>
// // // //                   <td style={{ color: record.approvalStatus === "Approved" ? "green" : "red" }}>{record.approvalStatus}</td>
// // // //                 </tr>
// // // //               ))}
// // // //             </tbody>
// // // //           </table>
// // // //         </>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // const approveButtonStyle = {
// // // //   backgroundColor: "green",
// // // //   color: "white",
// // // //   border: "none",
// // // //   padding: "8px 12px",
// // // //   marginRight: "10px",
// // // //   cursor: "pointer",
// // // //   borderRadius: "5px",
// // // // };

// // // // const rejectButtonStyle = {
// // // //   backgroundColor: "red",
// // // //   color: "white",
// // // //   border: "none",
// // // //   padding: "8px 12px",
// // // //   cursor: "pointer",
// // // //   borderRadius: "5px",
// // // // };

// // // // const tdStyle = {
// // // //   fontSize: "18px",
// // // //   padding: "12px",
// // // //   borderBottom: "1px solid #ddd",
// // // //   textAlign: "center",
// // // // };

// // // // const manualButtonStyle = {
// // // //   backgroundColor: "black",
// // // //   color: "white",
// // // //   border: "none",
// // // //   padding: "16px 16px",
// // // //   marginBottom: "10px",
// // // //   cursor: "pointer",
// // // //   borderRadius: "5px",
// // // //   // padding: "1%",
// // // //   fontSize: "20px",
// // // //   fontWeight: "bold",
// // // // };
// // // // export default DriverAdvance;

// // // import React, { useEffect, useState } from "react";
// // // import axios from "axios";
// // // import ManualRequestForm from "./ManualRequestForm";
// // // import { saveAs } from "file-saver";

// // // const DriverAdvance = () => {
// // //   const [advances, setAdvances] = useState([]);
// // //   const [records, setRecords] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [showManualForm, setShowManualForm] = useState(false);
// // //   const [searchTerm, setSearchTerm] = useState("");
// // //   const [selectedDate, setSelectedDate] = useState("");

// // //   const [driveId, setDriveId] = useState('');
// // //   const [driverName, setDriverName] = useState('');
// // //   const [fromDate, setFromDate] = useState('');
// // //   const [toDate, setToDate] = useState('');

// // //   const toggleManualForm = () => {
// // //     setShowManualForm(!showManualForm);
// // //   };

// // //   // ✅ Fetch advance requests
// // //   const fetchAdvanceRequests = async () => {
// // //     try {
// // //       const pendingResponse = await axios.get(
// // //         API_BASE_URL + "/advance/pending"
// // //       );
// // //       setAdvances(pendingResponse.data);

// // //       // 2) Get Approved/Rejected
// // //       const recordsResponse = await axios.get(
// // //         API_BASE_URL + "/advance/records"
// // //       );
// // //       setRecords(recordsResponse.data);
// // //       setLoading(false);
// // //     } catch (error) {
// // //       console.error("Error fetching advance requests:", error);
// // //       setLoading(false);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     fetchAdvanceRequests();
// // //   }, []);

// // //   const handleApproval = async (advanceId, status, requestedAmount) => {
// // //     let approvedAmount = 0;
// // //     if (status === "Approved") {
// // //       approvedAmount = parseFloat(prompt(`Enter approved amount:`));

// // //       if (
// // //         isNaN(approvedAmount) ||
// // //         approvedAmount <= 0 ||
// // //         approvedAmount > requestedAmount
// // //       ) {
// // //         alert(
// // //           `Invalid approved amount. It should be a number and <= ₹${requestedAmount}`
// // //         );
// // //         return;
// // //       }
// // //     }

// // //     try {
// // //       await axios.post(API_BASE_URL + "/advance/approve", {
// // //         advanceId,
// // //         status,
// // //         approvedAmount,
// // //         approvedAt: new Date(), // Save the approval date
// // //         adminId: "admin123", // Example adminId
// // //         adminName: "Admin User", // Example adminName
// // //       });

// // //       alert(`Advance ${status} successfully`);
// // //       fetchAdvanceRequests(); // <--- Re-fetch your data here!
// // //     } catch (error) {
// // //       console.error(`Error ${status.toLowerCase()}ing advance request:`, error);
// // //       alert("Error: " + (error?.response?.data?.message || error.message || "Failed to update advance request."));
// // //     }
// // //   };
// // //   const handleSearch = (e) => {
// // //     setSearchTerm(e.target.value);
// // //   };

// // //   const filteredRecords = records.filter(
// // //     (record) =>
// // //       record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
// // //       record.driverName.toLowerCase().includes(searchTerm.toLowerCase())
// // //   );

// // //   const handleDownload = (filterType) => {
// // //     let filteredData = records;
// // //     if (filterType === "driver" && searchTerm) {
// // //       filteredData = records.filter(
// // //         (record) =>
// // //           record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
// // //           record.driverName.toLowerCase().includes(searchTerm.toLowerCase())
// // //       );
// // //     } else if (filterType === "date" && selectedDate) {
// // //       filteredData = records.filter((record) => record.month === selectedDate);
// // //     }

// // //     const csvData = [
// // //       [
// // //         "Driver Id",
// // //         "Driver Name",
// // //         "Date",
// // //         "Requested Amount",
// // //         "Approved Amount",
// // //         "Status",
// // //       ].join(","),
// // //     ];
// // //     filteredData.forEach((record) => {
// // //       csvData.push(
// // //         [
// // //           record.driverId,
// // //           record.driverName,
// // //           record.month,
// // //           `₹${record.requestedAmount}`,
// // //           record.approvalStatus === "Approved"
// // //             ? `₹${record.approvedAmount}`
// // //             : "-",
// // //           record.approvalStatus,
// // //         ].join(",")
// // //       );
// // //     });

// // //     const blob = new Blob([csvData.join("\n")], {
// // //       type: "text/csv;charset=utf-8;",
// // //     });
// // //     saveAs(blob, "Advance_Report.csv");
// // //   };

// // //   return (
// // //     <div
// // //       style={{
// // //         padding: "20px",
// // //         background: "white",
// // //         color: "black",
// // //         maxWidth: "90%", // Adjusted for better responsiveness
// // //         margin: "auto",
// // //         borderRadius: "12px", // Slightly more rounded for a smooth look
// // //         marginLeft: "10%",
// // //         boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", // Soft shadow for a premium feel
// // //         border: "2px solid #FFC107", // Subtle mango yellow border
// // //       }}
// // //     >
// // //       <h2
// // //         style={{
// // //           textAlign: "center",
// // //           fontSize: "34px",
// // //           background: "#FFC107",
// // //           color: "black",
// // //           padding: "12px",
// // //           borderRadius: "10px", // More refined border radius
// // //           marginBottom: "50px", // Slightly reduced for balanced spacing
// // //           fontWeight: "bold",
// // //           letterSpacing: "1px",
// // //           textTransform: "uppercase", // More impact
// // //           boxShadow: "0 3px 6px rgba(255, 193, 7, 0.3)", // Soft glow effect
// // //         }}
// // //       >
// // //         Advance Approval Management
// // //       </h2>
// // //       <div>
// // //         <button onClick={toggleManualForm} style={manualButtonStyle}>
// // //           Add Manual Advance Request
// // //         </button>

// // //         {showManualForm && (
// // //           <ManualRequestForm
// // //             onClose={toggleManualForm}
// // //             refreshData={fetchAdvanceRequests}
// // //           />
// // //         )}
// // //       </div>
// // //       {loading ? (
// // //         <p>Loading advance requests...</p>
// // //       ) : advances.length === 0 ? (
// // //         <p>No advance requests available.</p>
// // //       ) : (
// // //         <>
// // //           <h3>Pending Advance Requests</h3>
// // //           <table style={{ width: "100%", borderCollapse: "collapse" }}>
// // //             <thead>
// // //               <tr
// // //                 style={{
// // //                   background: "#007bff",
// // //                   color: "white",
// // //                   fontSize: "24px",
// // //                   paddingTop: "2rem",
// // //                 }}
// // //               >
// // //                 <th>Driver Id</th>
// // //                 <th>Driver Name</th>
// // //                 <th>Month</th>
// // //                 <th>Requested Amount</th>
// // //                 <th>Action</th>
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {advances.map((advance) => (
// // //                 <tr
// // //                   key={advance._id}
// // //                   style={{ borderBottom: "1px solid #ddd" }}
// // //                 >
// // //                   <td style={tdStyle}>{advance.driverId}</td>
// // //                   <td style={tdStyle}>{advance.driverName}</td>
// // //                   <td style={tdStyle}>{advance.month}</td>
// // //                   <td style={tdStyle}>₹{advance.requestedAmount}</td>
// // //                   <td style={tdStyle}>
// // //                     <button
// // //                       onClick={() =>
// // //                         handleApproval(
// // //                           advance._id,
// // //                           "Approved",
// // //                           advance.requestedAmount
// // //                         )
// // //                       }
// // //                       style={approveButtonStyle}
// // //                     >
// // //                       Approve
// // //                     </button>
// // //                     <button
// // //                       onClick={() =>
// // //                         handleApproval(
// // //                           advance._id,
// // //                           "Rejected",
// // //                           advance.requestedAmount
// // //                         )
// // //                       }
// // //                       style={rejectButtonStyle}
// // //                     >
// // //                       Reject
// // //                     </button>
// // //                   </td>
// // //                 </tr>
// // //               ))}
// // //             </tbody>
// // //           </table>
// // //         </>
// // //       )}

// // //       {records.length > 0 && (
// // //         <>
// // //             {/* <div style={{ margin: "20px 0" }}>
// // //         <input
// // //           type="text"
// // //           placeholder="Search by Driver Id or Name"
// // //           value={searchTerm}
// // //           onChange={(e) => setSearchTerm(e.target.value)}
// // //           style={{ marginRight: "10px", padding: "10px", width: "10%" }}
// // //         />
// // //         <button
// // //           onClick={() => handleDownload("driver")}
// // //           style={downloadButtonStyle}
// // //         >
// // //           Download Filtered Report
// // //         </button>
// // //       </div>

// // //       <div>
// // //         <input
// // //           type="date"
// // //           value={selectedDate}
// // //           onChange={(e) => setSelectedDate(e.target.value)}
// // //           style={{ marginRight: "10px", padding: "10px" }}
// // //         />
// // //         <button
// // //           onClick={() => handleDownload("date")}
// // //           style={downloadButtonStyle}
// // //         >
// // //           Download Full Report by Date
// // //         </button>
// // //       </div> */}
// // //           <h3>Records Table</h3>
// // //           {/* <input
// // //             type="text"
// // //             placeholder="Search by Driver Id or Name"
// // //             value={searchTerm}
// // //             onChange={handleSearch}
// // //             style={{ marginBottom: "20px", padding: "10px", width: "99%" }}
// // //           /> */}
// // //           <table
// // //             style={{
// // //               width: "100%",
// // //               borderCollapse: "collapse",
// // //               textAlign: "center",
// // //             }}
// // //           >
// // //             <thead>
// // //               <tr
// // //                 style={{
// // //                   background: "black",
// // //                   color: "white",
// // //                   fontSize: "24px",
// // //                   fontWeight: "bold",
// // //                   padding: "1rem",
// // //                   textAlign: "center",
// // //                   height: "4rem",
// // //                   letterSpacing: "1px",
// // //                   borderBottom: "4px solid #FFC107", // Mango Yellow Border for a premium feel
// // //                   boxShadow: "0 4px 8px rgba(255, 193, 7, 0.3)", // Subtle mango yellow glow
// // //                   textTransform: "uppercase", // For a sleek header effect
// // //                 }}
// // //               >
// // //                 <th>Driver Id</th>
// // //                 <th>Driver Name</th>
// // //                 <th>Requested Date</th>
// // //                 <th>Requested Amount</th>
// // //                 <th>Approved Amount</th>
// // //                 <th>Status</th>
// // //                 {/* <th>Requested Date</th> */}
// // //                 <th>Paid Date</th>
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {filteredRecords.map((record) => (
// // //                 <tr key={record._id} style={{ borderBottom: "1px solid #ddd" }}>
// // //                   <td>{record.driverId}</td>
// // //                   <td>{record.driverName}</td>
// // //                   <td>
// // //                     {new Date(record.requestedAt).toLocaleString("en-GB", {
// // //                       day: "2-digit",
// // //                       month: "2-digit",
// // //                       year: "numeric",
// // //                       hour: "2-digit",
// // //                       minute: "2-digit",
// // //                       second: "2-digit",
// // //                       hour12: true,
// // //                     })}
// // //                   </td>
// // //                   <td>₹{record.requestedAmount}</td>
// // //                   <td>
// // //                     {record.approvalStatus === "Approved"
// // //                       ? `₹${record.approvedAmount}`
// // //                       : "-"}
// // //                   </td>
// // //                   <td
// // //                     style={{
// // //                       color:
// // //                         record.approvalStatus === "Approved" ? "green" : "red",
// // //                     }}
// // //                   >
// // //                     {record.approvalStatus}
// // //                   </td>

// // //                 </tr>
// // //               ))}
// // //             </tbody>
// // //           </table>
// // //           <div></div>
// // //         </>
// // //       )}

// // //     </div>
// // //   );
// // // };

// // // const approveButtonStyle = {
// // //   backgroundColor: "green",
// // //   color: "white",
// // //   border: "none",
// // //   padding: "8px 12px",
// // //   marginRight: "10px",
// // //   cursor: "pointer",
// // //   borderRadius: "5px",
// // // };

// // // const rejectButtonStyle = {
// // //   backgroundColor: "red",
// // //   color: "white",
// // //   border: "none",
// // //   padding: "8px 12px",
// // //   cursor: "pointer",
// // //   borderRadius: "5px",
// // // };

// // // const tdStyle = {
// // //   fontSize: "18px",
// // //   padding: "12px",
// // //   borderBottom: "1px solid #ddd",
// // //   textAlign: "center",
// // // };

// // // const manualButtonStyle = {
// // //   backgroundColor: "black",
// // //   color: "white",
// // //   border: "none",
// // //   padding: "16px 16px",
// // //   marginBottom: "10px",
// // //   cursor: "pointer",
// // //   borderRadius: "5px",
// // //   // padding: "1%",
// // //   fontSize: "20px",
// // //   fontWeight: "bold",
// // // };
// // // const downloadButtonStyle = {
// // //   backgroundColor: "black",
// // //   color: "white",
// // //   border: "none",
// // //   padding: "10px 15px",
// // //   cursor: "pointer",
// // //   borderRadius: "5px",
// // //   fontSize: "16px",
// // //   fontWeight: "bold",
// // // };

// // // export default DriverAdvance;

// // import React, { useEffect, useState } from "react";

// // import axios from "axios";

// // import ManualRequestForm from "./ManualRequestForm";

// // const DriverAdvance = () => {
// //   const [advances, setAdvances] = useState([]);

// //   const [records, setRecords] = useState([]);

// //   const [loading, setLoading] = useState(true);

// //   const [showManualForm, setShowManualForm] = useState(false);

// //   const [searchTerm, setSearchTerm] = useState("");

// //   const [fromDate, setFromDate] = useState("");

// //   const [toDate, setToDate] = useState("");

// //   const toggleManualForm = () => {
// //     setShowManualForm(!showManualForm);
// //   };

// //   // Fetch Advance Requests

// //   const fetchAdvanceRequests = async () => {
// //     try {
// //       const pendingResponse = await axios.get(
// //         API_BASE_URL + "/advance/pending"
// //       );

// //       setAdvances(pendingResponse.data);

// //       const recordsResponse = await axios.get(
// //         API_BASE_URL + "/advance/records"
// //       );

// //       setRecords(recordsResponse.data);

// //       setLoading(false);
// //     } catch (error) {
// //       console.error("Error fetching advance requests:", error);

// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchAdvanceRequests();
// //   }, []);

// //   const handleApproval = async (advanceId, status, requestedAmount) => {
// //     let approvedAmount = 0;

// //     if (status === "Approved") {
// //       approvedAmount = parseFloat(prompt(`Enter approved amount:`));

// //       if (
// //         isNaN(approvedAmount) ||
// //         approvedAmount <= 0 ||
// //         approvedAmount > requestedAmount
// //       ) {
// //         alert(
// //           `Invalid approved amount. It should be a number and <= ₹${requestedAmount}`
// //         );

// //         return;
// //       }
// //     }

// //     try {
// //       await axios.post(API_BASE_URL + "/advance/approve", {
// //         advanceId,

// //         status,

// //         approvedAmount,

// //         approvedAt: new Date(),

// //         adminId: "admin123",

// //         adminName: "Admin User",
// //       });

// //       alert(`Advance ${status} successfully`);

// //       fetchAdvanceRequests();
// //     } catch (error) {
// //       console.error(`Error ${status.toLowerCase()}ing advance request:`, error);

// //       alert("Error: " + (error?.response?.data?.message || error.message || "Failed to update advance request."));
// //     }
// //   };

// //   const handleSearch = () => {
// //     console.log("Searching with:", { searchTerm, fromDate, toDate });
// //   };

// //   const handleDownload = () => {
// //     console.log("Downloading data...");
// //   };

// //   const filteredRecords = records.filter(
// //     (record) =>
// //       record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //       record.driverName.toLowerCase().includes(searchTerm.toLowerCase())
// //   );

// //   return (
// //     <div style={containerStyle}>
// //       <h2 style={headerStyle}>Advance Approval Management</h2>

// //       {/* Manual Advance Request Button */}
// //       <div>
// //         <button onClick={toggleManualForm} style={manualButtonStyle}>
// //           Add Manual Advance Request
// //         </button>

// //         {showManualForm && (
// //           <ManualRequestForm
// //             onClose={toggleManualForm}
// //             refreshData={fetchAdvanceRequests}
// //           />
// //         )}
// //       </div>

// //       {/* Search Component */}
// //       <div style={searchContainerStyle}>
// //         <h3>Search Records</h3>
// //         <input
// //           type="text"
// //           placeholder="Search by Driver Id or Name"
// //           value={searchTerm}
// //           onChange={(e) => setSearchTerm(e.target.value)}
// //           style={inputStyle}
// //         />
// //         <input
// //           type="date"
// //           value={fromDate}
// //           onChange={(e) => setFromDate(e.target.value)}
// //           style={inputStyle}
// //         />
// //         <input
// //           type="date"
// //           value={toDate}
// //           onChange={(e) => setToDate(e.target.value)}
// //           style={inputStyle}
// //         />
// //         <div style={{ marginTop: "10px" }}>
// //           <button onClick={handleSearch} style={searchButtonStyle}>
// //             Search
// //           </button>
// //           <button onClick={handleDownload} style={downloadButtonStyle}>
// //             Download
// //           </button>
// //         </div>
// //       </div>

// //       {/* Pending Advance Requests */}

// //       {loading ? (
// //         <p>Loading advance requests...</p>
// //       ) : advances.length === 0 ? (
// //         <p>No advance requests available.</p>
// //       ) : (
// //         <>
// //           <h3>Pending Advance Requests</h3>
// //           <table style={tableStyle}>
// //             <thead>
// //               <tr style={theadStyle}>
// //                 <th>Driver Id</th>
// //                 <th>Driver Name</th>
// //                 <th>Month</th>
// //                 <th>Requested Amount</th>
// //                 <th>Action</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {advances.map((advance) => (
// //                 <tr key={advance._id} style={rowStyle}>
// //                   <td style={tdStyle}>{advance.driverId}</td>
// //                   <td style={tdStyle}>{advance.driverName}</td>
// //                   <td style={tdStyle}>{advance.month}</td>
// //                   <td style={tdStyle}>₹{advance.requestedAmount}</td>
// //                   <td style={tdStyle}>
// //                     <button
// //                       onClick={() =>
// //                         handleApproval(
// //                           advance._id,
// //                           "Approved",
// //                           advance.requestedAmount
// //                         )
// //                       }
// //                       style={approveButtonStyle}
// //                     >
// //                       Approve
// //                     </button>
// //                     <button
// //                       onClick={() =>
// //                         handleApproval(
// //                           advance._id,
// //                           "Rejected",
// //                           advance.requestedAmount
// //                         )
// //                       }
// //                       style={rejectButtonStyle}
// //                     >
// //                       Reject
// //                     </button>
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </>
// //       )}

// //       {/* Records Table */}

// //       {records.length > 0 && (
// //         <>
// //           <h3>Records Table</h3>
// //           <table style={tableStyle}>
// //             <thead>
// //               <tr style={theadStyle}>
// //                 <th>Driver Id</th>
// //                 <th>Driver Name</th>
// //                 <th>Date</th>
// //                 <th>Requested Amount</th>
// //                 <th>Approved Amount</th>
// //                 <th>Status</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {filteredRecords.map((record) => (
// //                 <tr key={record._id} style={rowStyle}>
// //                   <td>{record.driverId}</td>
// //                   <td>{record.driverName}</td>
// //                   <td>{record.month}</td>
// //                   <td>₹{record.requestedAmount}</td>
// //                   <td>
// //                     {record.approvalStatus === "Approved"
// //                       ? `₹${record.approvedAmount}`
// //                       : "-"}
// //                   </td>
// //                   <td
// //                     style={{
// //                       color:
// //                         record.approvalStatus === "Approved" ? "green" : "red",
// //                     }}
// //                   >
// //                     {record.approvalStatus}
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </>
// //       )}
// //     </div>
// //   );
// // };

// // // Styles

// // const containerStyle = {
// //   padding: "20px",

// //   background: "white",

// //   color: "black",

// //   maxWidth: "90%",

// //   margin: "2rem 2rem 2rem 14%",

// //   borderRadius: "12px",

// //   boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",

// //   border: "2px solid #FFC107",
// // };

// // const headerStyle = {
// //   textAlign: "center",

// //   fontSize: "34px",

// //   background: "#FFC107",

// //   padding: "12px",

// //   borderRadius: "10px",

// //   marginBottom: "20px",

// //   fontWeight: "bold",
// // };

// // const searchContainerStyle = {
// //   marginBottom: "20px",

// //   padding: "10px",

// //   background: "#f8f9fa",

// //   borderRadius: "8px",
// // };

// // const inputStyle = {
// //   padding: "10px",

// //   margin: "5px",

// //   width: "23%",
// // };

// // const searchButtonStyle = {
// //   backgroundColor: "black",

// //   color: "white",

// //   padding: "10px",

// //   borderRadius: "5px",

// //   cursor: "pointer",
// // };

// // const downloadButtonStyle = {
// //   backgroundColor: "#FFC107",

// //   color: "black",

// //   padding: "10px",

// //   borderRadius: "5px",

// //   cursor: "pointer",

// //   marginLeft: "10px",
// // };

// // const tableStyle = { width: "100%", borderCollapse: "collapse" };

// // const theadStyle = { background: "black", color: "white",textAlign:"center" };

// // const rowStyle = { borderBottom: "1px solid #ddd",textAlign:"center" };

// // const tdStyle = { padding: "10px", textAlign: "center" };


// // const manualButtonStyle = {
// //   backgroundColor: "black",
// //   color: "white",
// //   border: "none",
// //   padding: "16px 16px",
// //   marginBottom: "10px",
// //   cursor: "pointer",
// //   borderRadius: "5px",
// //   // padding: "1%",
// //   fontSize: "20px",
// //   fontWeight: "bold",
// // };

// // const approveButtonStyle = {
// //   backgroundColor: "green",
// //   color: "white",
// //   border: "none",
// //   padding: "8px 12px",
// //   marginRight: "10px",
// //   cursor: "pointer",
// //   borderRadius: "5px",
// // };

// // const rejectButtonStyle = {
// //   backgroundColor: "red",
// //   color: "white",
// //   border: "none",
// //   padding: "8px 12px",
// //   cursor: "pointer",
// //   borderRadius: "5px",
// // };

// // export default DriverAdvance;


 
// const DriverAdvance = () => {
//   const [advances, setAdvances] = useState([]);
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showManualForm, setShowManualForm] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("All");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
 
//   const toggleManualForm = () => {
//     setShowManualForm(!showManualForm);
//   };
 
//   // Fetch Advance Requests
//   const fetchAdvanceRequests = async () => {
//     try {
//       const pendingResponse = await axios.get(
//         API_BASE_URL + "/advance/pending"
//       );
//       setAdvances(pendingResponse.data);
 
//       const recordsResponse = await axios.get(
//         API_BASE_URL + "/advance/records"
//       );
//       setRecords(recordsResponse.data);
 
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching advance requests:", error);
//       setLoading(false);
//     }
//   };
 
//   useEffect(() => {
//     fetchAdvanceRequests();
//   }, []);
 
//   const handleApproval = async (advanceId, status, requestedAmount) => {
//     let approvedAmount = 0;
 
//     if (status === "Approved") {
//       approvedAmount = parseFloat(prompt(`Enter approved amount:`));
 
//       if (
//         isNaN(approvedAmount) ||
//         approvedAmount <= 0 ||
//         approvedAmount > requestedAmount
//       ) {
//         alert(
//           `Invalid approved amount. It should be a number and <= ₹${requestedAmount}`
//         );
//         return;
//       }
//     }
 
//     try {
//       await axios.post(API_BASE_URL + "/advance/approve", {
//         advanceId,
//         status,
//         approvedAmount,
//         approvedAt: new Date(),
//         adminId: "admin123",
//         adminName: "Admin User",
//       });
//       alert(`Advance ${status} successfully`);
//       fetchAdvanceRequests();
//     } catch (error) {
//       console.error(`Error ${status.toLowerCase()}ing advance request:`, error);
//       alert("Error: " + (error?.response?.data?.message || error.message || "Failed to update advance request."));
//     }
//   };
 
//   const handleSearch = () => {
//     console.log("Searching with:", { searchTerm, statusFilter, startDate, endDate });
//   };
 
//   const handleDownload = () => {
//     console.log("Downloading data...");
 
//     // Prepare data for download
//     const filteredData = records.filter((record) => {
//       const recordDate = new Date(record.month);
//       const fromDateValid = startDate ? new Date(startDate) <= recordDate : true;
//       const toDateValid = endDate ? new Date(endDate) >= recordDate : true;
 
//       const statusValid =
//         statusFilter === "All" || record.approvalStatus === statusFilter;
 
//       return (
//         (record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           record.driverName.toLowerCase().includes(searchTerm.toLowerCase())) &&
//         fromDateValid &&
//         toDateValid &&
//         statusValid
//       );
//     });
 
//     // You can either convert the filteredData into a CSV format or any other downloadable format
//     const csvContent = `Driver Id, Driver Name, Date, Requested Amount, Approved Amount, Status\n` +
//     filteredData.map(record =>
//       `${record.driverId}, ${record.driverName}, ${record.month}, ₹${record.requestedAmount}, ₹${record.approvedAmount || ''}, ${record.approvalStatus}`
//     ).join("\n");
 
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement("a");
//     if (link.download !== undefined) {
//       link.setAttribute("href", URL.createObjectURL(blob));
//       link.setAttribute("download", "advance_records.csv");
//       link.click();
//     }
//   };
 
//   const filteredRecords = records.filter((record) => {
//     const recordDate = new Date(record.month);
//     const fromDateValid = startDate ? new Date(startDate) <= recordDate : true;
//     const toDateValid = endDate ? new Date(endDate) >= recordDate : true;
 
//     const statusValid =
//       statusFilter === "All" || record.approvalStatus === statusFilter;
 
//     return (
//       (record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         record.driverName.toLowerCase().includes(searchTerm.toLowerCase())) &&
//       fromDateValid &&
//       toDateValid &&
//       statusValid
//     );
//   });
 
//   return (
//     <div style={styles.containerStyle}>
//       <h2 className="sendo-heading">Driver Advance</h2>
//       <h2 style={styles.headerStyle}>Advance Approval Management</h2>
 
//       {/* Manual Advance Request Button */}
//       <div>
//         <button onClick={toggleManualForm} style={styles.manualButtonStyle}>
//           Add Manual Advance Request
//         </button>
 
//         {showManualForm && (
//           <ManualRequestForm
//             onClose={toggleManualForm}
//             refreshData={fetchAdvanceRequests}
//           />
//         )}
//       </div>
 
//       {/* Filter Container */}
//       <div style={styles.filterContainer}>
//         <input
//           type="text"
//           placeholder="Search by Driver Name..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           style={styles.input}
//         />
//         <select
//           value={statusFilter}
//           onChange={(e) => setStatusFilter(e.target.value)}
//           style={styles.input}
//         >
//           <option value="All">All</option>
//           <option value="Approved">Approved</option>
//           <option value="Rejected">Rejected</option>
//           <option value="Pending">Pending</option>
//         </select>
//         <input
//           type="date"
//           value={startDate}
//           onChange={(e) => setStartDate(e.target.value)}
//           style={styles.input}
//         />
//         <input
//           type="date"
//           value={endDate}
//           onChange={(e) => setEndDate(e.target.value)}
//           style={styles.input}
//         />
//         <button onClick={handleDownload} style={styles.button}>
//           Download
//         </button>
//       </div>
 
//       {/* Pending Advance Requests */}
//       {loading ? (
//         <p>Loading advance requests...</p>
//       ) : advances.length === 0 ? (
//         <p>No advance requests available.</p>
//       ) : (
//         <>
//           <h3>Pending Advance Requests</h3>
//           <table style={styles.tableStyle}>
//             <thead>
//               <tr style={styles.theadStyle}>
//                 <th>Driver Id</th>
//                 <th>Driver Name</th>
//                 <th>Month</th>
//                 <th>Requested Amount</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {advances.map((advance) => (
//                 <tr key={advance._id} style={styles.rowStyle}>
//                   <td style={styles.tdStyle}>{advance.driverId}</td>
//                   <td style={styles.tdStyle}>{advance.driverName}</td>
//                   <td style={styles.tdStyle}>{advance.month}</td>
//                   <td style={styles.tdStyle}>₹{advance.requestedAmount}</td>
//                   <td style={styles.tdStyle}>
//                     <button
//                       onClick={() =>
//                         handleApproval(
//                           advance._id,
//                           "Approved",
//                           advance.requestedAmount
//                         )
//                       }
//                       style={styles.approveButtonStyle}
//                     >
//                       Approve
//                     </button>
//                     <button
//                       onClick={() =>
//                         handleApproval(
//                           advance._id,
//                           "Rejected",
//                           advance.requestedAmount
//                         )
//                       }
//                       style={styles.rejectButtonStyle}
//                     >
//                       Reject
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </>
//       )}
 
//       {/* Records Table */}
//       {records.length > 0 && (
//         <>
//           <h3>Records Table</h3>
//           <table style={styles.tableStyle}>
//             <thead>
//               <tr style={styles.theadStyle}>
//                 <th >Driver Id</th>
//                 <th>Driver Name</th>
//                 <th>Date</th>
//                 <th>Requested Amount</th>
//                 <th>Approved Amount</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredRecords.map((record) => (
//                 <tr key={record._id} style={styles.rowStyle}>
//                   <td style={styles.tdStyle}> {record.driverId}</td>
//                   <td style={styles.tdStyle}>{record.driverName}</td>
//                   <td style={styles.tdStyle}>{record.month}</td>
//                   <td style={styles.tdStyle}>₹{record.requestedAmount}</td>
//                   <td style={styles.tdStyle}>
//                     {record.approvalStatus === "Approved"
//                       ? `₹${record.approvedAmount}`
//                       : "-"}
//                   </td>
//                   <td 
//                     style={{
//                       color:
//                         record.approvalStatus === "Approved" ? "#FFC107" : "black",
//                     }}
//                   >
//                     {record.approvalStatus}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </>
//       )}
//     </div>
//   );
// };
 
// // Styles for the filter section and the entire layout
// const styles = {
//   containerStyle: {
//     padding: "20px",
//     backgroundColor: "#fff",
//     minHeight: "100vh",
//     marginLeft: "270px",
//   },
 
//   headerStyle: {
//     backgroundColor:"#FFC107",
//     color: "black", // black header text
//     fontSize: "24px",
//     marginBottom: "20px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height:"45px",
//   },
//   manualButtonStyle: {
//     padding: "10px 15px",
//     backgroundColor: "black", // mango yellow button
//     color: "white",
//     border: "none",
//     borderRadius: "5px",
//     cursor: "pointer",
//     marginBottom:"5px"
//   },
//   filterContainer: {
//     marginBottom: "20px",
//   },
//   input: {
//     padding: "5px",
//     marginRight: "10px",
//     borderRadius: "5px",
//     border: "1px solid #ccc",
//   },
//   button: {
//     padding: "5px 15px",
//     backgroundColor: "black", // mango yellow button
//     color: "white",
//     border: "none",
//     borderRadius: "5px",
//     cursor: "pointer",
//   },
//   tableStyle: {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginBottom: "20px",
//   },
//   theadStyle: {
//     backgroundColor: "black", // black header background
//     color: "white", // white text color
//     height:"40px",
//   },
//   rowStyle: {
//     backgroundColor: "#f9f9f9",
//   },
//   tdStyle: {
//     padding: "10px",
//     border: "1px solid #ccc",
//     textAlign: "center",
//   },
//   approveButtonStyle: {
//     padding: "5px 10px",
//     backgroundColor: "#FFC107",
//     color: "black",
//     fontWeight: "bold",
//     border: "none",
//     borderRadius: "5px",
//     cursor: "pointer",
//   },
//   rejectButtonStyle: {
//     padding: "5px 10px",
//     backgroundColor: "black",
//     color: "white",
//     border: "none",
//     fontWeight: "bold",
//     marginLeft:"10px",
//     width:"80px",
//     borderRadius: "5px",
//     cursor: "pointer",
//   },
// };
 
// export default DriverAdvance;
import React, { useState, useEffect } from "react";
import axios from "axios";
import ManualRequestForm from "./ManualRequestForm";
import API_BASE_URL from "../config";

const DriverAdvance = () => {
  const [advances, setAdvances] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showManualForm, setShowManualForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const toggleManualForm = () => setShowManualForm(!showManualForm);

  const fetchAdvanceRequests = async () => {
    try {
      const pendingResponse = await axios.get(API_BASE_URL + "/advance/pending");
      setAdvances(pendingResponse.data);
      const recordsResponse = await axios.get(API_BASE_URL + "/advance/records");
      setRecords(recordsResponse.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching advance requests:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvanceRequests();
  }, []);

  const handleApproval = async (advanceId, status, requestedAmount) => {
    let approvedAmount = 0;
    if (status === "Approved") {
      approvedAmount = parseFloat(prompt(`Enter approved amount:`));
      if (isNaN(approvedAmount) || approvedAmount <= 0 || approvedAmount > requestedAmount) {
        alert(`Invalid approved amount. It should be a number and <= ₹${requestedAmount}`);
        return;
      }
    }
    try {
      await axios.post(API_BASE_URL + "/advance/approve", {
        advanceId, status, approvedAmount,
        approvedAt: new Date(), adminId: "admin123", adminName: "Admin User",
      });
      alert(`Advance ${status} successfully`);
      fetchAdvanceRequests();
    } catch (error) {
      console.error(`Error ${status.toLowerCase()}ing advance request:`, error);
      alert("Error: " + (error?.response?.data?.message || error.message || "Failed to update advance request."));
    }
  };

  const handleDownload = () => {
    const filteredData = records.filter((record) => {
      const recordDate = new Date(record.month);
      const fromDateValid = startDate ? new Date(startDate) <= recordDate : true;
      const toDateValid = endDate ? new Date(endDate) >= recordDate : true;
      const statusValid = statusFilter === "All" || record.approvalStatus === statusFilter;
      return (
        (record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
          record.driverName.toLowerCase().includes(searchTerm.toLowerCase())) &&
        fromDateValid && toDateValid && statusValid
      );
    });
    const csvContent =
      `Driver Id,Driver Name,Date,Requested Amount,Approved Amount,Status\n` +
      filteredData.map((r) =>
        `${r.driverId},${r.driverName},${r.month},₹${r.requestedAmount},₹${r.approvedAmount || ""},${r.approvalStatus}`
      ).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", "advance_records.csv");
    link.click();
  };

  const filteredRecords = records.filter((record) => {
    const recordDate = new Date(record.month);
    const fromDateValid = startDate ? new Date(startDate) <= recordDate : true;
    const toDateValid = endDate ? new Date(endDate) >= recordDate : true;
    const statusValid = statusFilter === "All" || record.approvalStatus === statusFilter;
    return (
      (record.driverId.toLowerCase().includes(searchTerm.toLowerCase()) ||
        record.driverName.toLowerCase().includes(searchTerm.toLowerCase())) &&
      fromDateValid && toDateValid && statusValid
    );
  });

  const s = {
    container: {
      fontFamily: "Arial, sans-serif",
      marginLeft: "278px",
      marginRight: "10px",
      backgroundColor: "#ffffff",
      color: "#000000",
      minHeight: "100vh",
    },
    pageHeader: {
      backgroundColor: "#FFC107",
      padding: "16px 24px",
      marginBottom: "0px",
    },
    pageHeaderText: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#000000",
      letterSpacing: "1px",
      textTransform: "uppercase",
      margin: 0,
    },
    contentBody: {
      padding: "24px",
    },
    sectionTitle: {
      fontSize: "15px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "4px",
      marginTop: "20px",
    },
    sectionDivider: {
      border: "none",
      borderTop: "2px solid #FFC107",
      marginBottom: "16px",
    },
    filterContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      flexWrap: "wrap",
      marginBottom: "20px",
    },
    searchInput: {
      padding: "8px 10px",
      width: "220px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      color: "#000000",
      backgroundColor: "#ffffff",
      outline: "none",
    },
    filterSelect: {
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      color: "#000000",
      backgroundColor: "#ffffff",
      outline: "none",
    },
    dateInput: {
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      color: "#000000",
      backgroundColor: "#ffffff",
      outline: "none",
    },
    downloadButton: {
      padding: "8px 20px",
      backgroundColor: "#FFC107",
      color: "#000000",
      border: "none",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "13px",
    },
    manualButton: {
      padding: "8px 20px",
      backgroundColor: "#000000",
      color: "#ffffff",
      border: "none",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "13px",
      marginBottom: "16px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "8px",
    },
    th: {
      backgroundColor: "#000000",
      color: "#ffffff",
      padding: "12px 16px",
      textAlign: "center",
      fontSize: "13px",
      fontWeight: "700",
      border: "1px solid #000000",
    },
    td: {
      border: "1px solid #000000",
      padding: "10px 14px",
      color: "#000000",
      fontSize: "13px",
      textAlign: "center",
      backgroundColor: "#ffffff",
    },
    approveButton: {
      backgroundColor: "#FFC107",
      color: "#000000",
      border: "none",
      padding: "7px 16px",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "12px",
      display: "block",
      width: "88px",
      marginBottom: "5px",
    },
    rejectButton: {
      backgroundColor: "#000000",
      color: "#ffffff",
      border: "none",
      padding: "7px 16px",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "12px",
      display: "block",
      width: "88px",
    },
    statusBadge: (status) => ({
      display: "inline-block",
      padding: "4px 12px",
      backgroundColor:
        status === "Approved" ? "#FFC107" : status === "Rejected" ? "#000000" : "#ffffff",
      color:
        status === "Approved" ? "#000000" : status === "Rejected" ? "#ffffff" : "#000000",
      fontWeight: "700",
      fontSize: "12px",
      border: status === "Pending" ? "1.5px solid #000000" : "none",
    }),
  };

  return (
    <div style={s.container}>
      {/* Yellow header bar */}
      <div style={s.pageHeader}>
        <h1 style={s.pageHeaderText}>Advance Approval Management</h1>
      </div>

      <div style={s.contentBody}>

        {/* Manual Request Button */}
        <button onClick={toggleManualForm} style={s.manualButton}>
          Add Manual Advance Request
        </button>
        {showManualForm && (
          <ManualRequestForm onClose={toggleManualForm} refreshData={fetchAdvanceRequests} />
        )}

        {/* Filter Section */}
        <div style={s.sectionTitle}>Filter &amp; Search</div>
        <hr style={s.sectionDivider} />
        <div style={s.filterContainer}>
          <input
            type="text"
            placeholder="Search by Driver Name or ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={s.searchInput}
          />
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={s.filterSelect}>
            <option value="All">All</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
            <option value="Pending">Pending</option>
          </select>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} style={s.dateInput} />
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} style={s.dateInput} />
          <button onClick={handleDownload} style={s.downloadButton}>Download</button>
        </div>

        {/* Pending Requests */}
        <div style={s.sectionTitle}>Pending Advance Requests</div>
        <hr style={s.sectionDivider} />
        {loading ? (
          <p style={{ fontSize: "13px" }}>Loading advance requests...</p>
        ) : advances.length === 0 ? (
          <p style={{ fontSize: "13px" }}>No pending advance requests.</p>
        ) : (
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Driver ID</th>
                <th style={s.th}>Driver Name</th>
                <th style={s.th}>Month</th>
                <th style={s.th}>Requested Amount</th>
                <th style={s.th}>Action</th>
              </tr>
            </thead>
            <tbody>
              {advances.map((advance) => (
                <tr key={advance._id}>
                  <td style={s.td}>{advance.driverId}</td>
                  <td style={s.td}>{advance.driverName}</td>
                  <td style={s.td}>{advance.month}</td>
                  <td style={s.td}>₹{advance.requestedAmount}</td>
                  <td style={s.td}>
                    <button style={s.approveButton} onClick={() => handleApproval(advance._id, "Approved", advance.requestedAmount)}>
                      Approve
                    </button>
                    <button style={s.rejectButton} onClick={() => handleApproval(advance._id, "Rejected", advance.requestedAmount)}>
                      Reject
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Records Table */}
        {records.length > 0 && (
          <>
            <div style={{ ...s.sectionTitle, marginTop: "28px" }}>Records Table</div>
            <hr style={s.sectionDivider} />
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Driver ID</th>
                  <th style={s.th}>Driver Name</th>
                  <th style={s.th}>Date</th>
                  <th style={s.th}>Requested Amount</th>
                  <th style={s.th}>Approved Amount</th>
                  <th style={s.th}>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredRecords.map((record) => (
                  <tr key={record._id}>
                    <td style={s.td}>{record.driverId}</td>
                    <td style={s.td}>{record.driverName}</td>
                    <td style={s.td}>{record.month}</td>
                    <td style={s.td}>₹{record.requestedAmount}</td>
                    <td style={s.td}>
                      {record.approvalStatus === "Approved" ? `₹${record.approvedAmount}` : "—"}
                    </td>
                    <td style={s.td}>
                      <span style={s.statusBadge(record.approvalStatus)}>
                        {record.approvalStatus}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default DriverAdvance;